import { HttpErrorResponse } from '@angular/common/http';

/** Production (or older) APIs may not expose /privacy/terms yet. */
export function isTermsEndpointMissing(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.status === 404;
}
